import React, { useState, createContext, useContext, useMemo } from "react";

interface SearchContextType {
  isAddressSelected: boolean;
  setIsAddressSelected: Function;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export function AddressProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const contextValue = useMemo(
    () => ({ isAddressSelected, setIsAddressSelected }),
    [isAddressSelected, setIsAddressSelected],
  );
  return <SearchContext.Provider value={contextValue}>{children}</SearchContext.Provider>;
}

export const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("Something went wrong in schedule form search address");
  }
  return context;
};
